import React from 'react';
import { Card } from 'react-bootstrap';
import projImg8 from "../../assets/img/n7.png";
import projectimage8 from "../../assets/img/np8.png";
import ShowMoreText from "react-show-more-text";

const Card8 = () => {
    // Your component logic goes here

    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Diffusion of innovation in social networks</h2></Card.Title> */}

        <Card.Img variant="top" src={projectimage8} />
        <Card.Body>
          <Card.Text>
            {" "}
            <img className="img2" src={projImg8} />{" "}
            <p className="text7">Róbert Somogyi</p>
            <br />
            <p className="text8">
              Assistant Professor
              <br /> Department of Finance, BME
            </p>
          </Card.Text>
          <ShowMoreText lines={2}>
            <div>
              Deceptive pricing practices are ubiquitous in the economy in
              general, and in finance in particular. Examples include
              pressure selling tactics, hiding additional fees by drip
              pricing, and using complicated contracts that make comparing
              offers hard. For instance, credit card contracts are
              notoriously complex. Competition authorities, financial
              regulatory bodies, and consumer protection agencies
              worldwide seem increasingly concerned by these practices.
              Game theory and industrial economics offer a toolbox very
              well adapted to studying such regulatory issues.
              <br />
              <br />
            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Card8;
